export default "__VITE_ASSET__J_$K_pk5__ 400w, __VITE_ASSET__DcRmH0sf__ 800w, __VITE_ASSET__B7OeEw$x__ 1200w";